import { TransactionField } from "@/graphql"
import type { View } from "@/types"

export function withTransactionFields(view: View, fields: TransactionField[]): View {
	return {
		...view,
		select: {
			...view.select,
			// The inline editor also needs parking facts when their table columns are hidden.
			transaction: [
				...new Set([
					...fields,
					TransactionField.ParkingTypes,
					TransactionField.HasIndoorParking,
					TransactionField.HasOutdoorParking,
					TransactionField.ParkingIndoorCount,
					TransactionField.ParkingOutdoorCount,
				]),
			],
		},
	}
}
